import React, { useEffect, useMemo, useState } from "react";
import "../../theme/tailwind.css";
import { IProgramCertificatesDisplay } from "@interfaces/Components";
import { format, isAfter } from "date-fns";
import { IonSpinner } from "@ionic/react";
import * as StringUtils from "@utils/stringUtils";
import * as ProgramUtils from "@utils/programUtils";

const ProgramCertificatesDisplay: React.FC<IProgramCertificatesDisplay> = (props) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const [viewing, setViewing] = useState<boolean>(false);
  const [expired, setExpired] = useState<boolean>(false);

  useEffect(() => {
    setDisabled(props.viewingCertificate && props.viewingFilename !== props.certificate.certificate?.name);
    setViewing(props.viewingCertificate && props.viewingFilename === props.certificate.certificate?.name);
  }, [props.certificate, props.viewingCertificate, props.viewingFilename]);

  useEffect(() => {
    if (props.certificate.expiryDate) {
      const expiry = new Date(props.certificate.expiryDate);

      if (ProgramUtils.isSwastOrNwasEprrProgram(props.certificate.programData.programID)) {
        setExpired(StringUtils.isSwastNwasEprrCertificateExpired(expiry));
      } else {
        setExpired(isAfter(new Date(), expiry));
      }
    }
  }, [props.certificate.expiryDate, props.certificate.programData.programID]);

  const certificateHasRole = useMemo(() => {
    return props.roles?.includes(props.certificate.programData.role ?? "");
  }, [props.certificate, props.roles]);

  if (props.certificate.programData.role && !certificateHasRole) {
    return null;
  }

  // Special condition for SWAST EPRR to hide legacy supporting evidence certificate
  if (ProgramUtils.isSwastEPRR(props.programID ?? "") && props.certificate.programData.certificateType === "Supporting Evidence (Mandatory)") {
    return null;
  }

  return (
    <div>
      <div className="mt-[8px] mb-[12px]">
        <div className="text-[13px] leading-[1.54] tracking-[-0.1px] text-grey-70">
          {`${props.certificate.programData.certificateType} certificate`}
        </div>
        <div className="flex flex-row justify-between items-center">
          <button
            disabled={disabled}
            key={props.certificate.certificate?.name}
            onClick={() => !(disabled || viewing) && props.buttonPressed()}
            className={`flex min-w-0 flex-[-1] flex-row items-center !min-h-[26px] bg-transparent self-start mr-[8px] pointer-events-auto program-certificate-button
            ${viewing && "program-certificate-button-wait"} ${disabled && "program-certificate-button-disabled"}`}
          >
            <div className="text-[16px] leading-default tracking-default text-cta-blue whitespace-nowrap overflow-hidden text-ellipsis">
              {props.certificate.certificate?.name}
            </div>
            {viewing && <IonSpinner className="w-[15px] h-[15px] ml-[8px] text-cta-blue" />}
          </button>
          {props.certificate.expiryDate && (
            <div
              className={
                ProgramUtils.isSwastOrNwasEprrProgram(props.certificate.programData.programID)
                  ? StringUtils.getSwastNwasEprrCertificatePillContainerClassFromExpiryDate(
                      new Date(props.certificate.expiryDate)
                    )
                  : StringUtils.getCertificatePillContainerClassFromExpiryDate(new Date(props.certificate.expiryDate))
              }
            >
              {`${expired ? "Expired" : "Expires"} ${format(new Date(props.certificate.expiryDate), "d MMM yy")}`}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgramCertificatesDisplay;
